import { render, staticRenderFns } from "./ModalDeleteProgramItem.vue?vue&type=template&id=0ae4beea"
import script from "./ModalDeleteProgramItem.vue?vue&type=script&lang=js"
export * from "./ModalDeleteProgramItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports